import RegExpSpecialSymbols from "./RegExpSpecialSymbols"

// TODO: convert to class
export default function StringTokenizer( punctuators )
{
    this.punctuators = punctuators || StringTokenizer.DEFAULT_PUNCTUATORS;
    this.replacePunctuatorsPattern = new RegExp("[" + RegExpSpecialSymbols.escapeRegexpSpecialSymbols( this.punctuators ) + "]+", "g");
}

StringTokenizer.DEFAULT_PUNCTUATORS = "()-,.\"':";
StringTokenizer.PUNCTUATORS_FOR_SEARCH = StringTokenizer.DEFAULT_PUNCTUATORS.concat("!#$%&()*+,-.:;<=>?@]/[^_`{|}~\\");

StringTokenizer.prototype.getPunctuators = function()
{
    return this.punctuators;
};

StringTokenizer.prototype.getTokens = function( s )
{
    var results = [];
    var duplicates = {};

    var words = s.replace(this.replacePunctuatorsPattern, " ").split(/\s+/);

    for (var i=0; i< words.length; i++)
    {
        var w = words[i];
        if (w.length > 0 && !duplicates[w])
        {
            results.push(w);
            duplicates[w] = 1;
        }
    }

    return results;
};



// WEBPACK FOOTER //
// ./web/js/util/StringTokenizer.js